import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private auth: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = this.auth.currentToken;
    const user = this.auth.currentUser;
    if (token && token.key && !state.url.includes('auth') && user && user.organizations && (user.organizations.length > 0)) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.auth.isLoggeIn;
    this.router.navigate(['/auth/login']);
    return false;
  }

}
